import React from 'react';
import PropTypes from 'prop-types';
import lodashMap from 'lodash/map';
import ReactDataGrid from 'react-data-grid';
import { Row, Col, Button } from 'react-bootstrap';
import { Data, Toolbar } from 'react-data-grid-addons';
import ReactTooltip from 'react-tooltip';
import { Translate } from 'react-redux-i18n';

import { DateFormatter } from '../../../Common/dateFormat';
import { ROOT_URL, ROOT_API_URL, isOLG, isLMH, isSDR, isCRW } from '../../../../actions/root_url';

const isAFM = ROOT_API_URL === 'https://afm-scm.truckxi.com/api/' || ROOT_URL === 'https://afm-scm.truckxi.com/api/';

const propTypes = {
  promotions: PropTypes.shape({
    Description: PropTypes.string,
    Method: PropTypes.string,
    Name: PropTypes.string,
    ProductNum: PropTypes.string,
    Product_id: PropTypes.number,
    PromotionLine_id: PropTypes.number,
    RefNum: PropTypes.string,
    ProductGroupName: PropTypes.string,
    ProductCategoryName: PropTypes.string,
  }),
  tabsKey: PropTypes.string,
  handleGridSort: PropTypes.func,
  handleFilterChange: PropTypes.func,
  handleOpenEditPromotion: PropTypes.func,
  openDeletePromotion: PropTypes.func,
  handleClearFilters: PropTypes.func,
};

const defaultProps = {
  promotions: {},
  tabsKey: 'ByQuantity',
  handleGridSort: () => {},
  handleFilterChange: () => {},
  handleOpenEditPromotion: () => {},
  openDeletePromotion: () => {},
  handleClearFilters: () => {},
};

const PromotionsTable = ({
  promotions,
  tabsKey,
  handleGridSort,
  handleFilterChange,
  openDeletePromotion,
  handleOpenEditPromotion,
  handleClearFilters,
}) => {
  const getRows = () => Data.Selectors.getRows(promotions);

  const getSize = () => getRows().length;

  const rowGetter = (rowIdx) => {
    const rows = getRows();
    return rows[rowIdx];
  };

  const IsVariableFormatter = React.createClass({
    render() {
      return (
        <span>
          <Button
            bsStyle="danger"
            className="textAlignStyle"
            style={{ height: '23px', width: '39px', padding: '0px' }}
            onClick={() => {
              const { dependentValues } = this.props;
              openDeletePromotion(dependentValues.PromotionLine_id);
            }}
          >
            X
          </Button>
        </span>
      );
    },
  });

  const EditButtonFormatter = React.createClass({
    render() {
      return (
        <span>
          <Button
            bsStyle="warning"
            className="textAlignStyle"
            style={{ height: '23px', width: '39px', padding: '0px' }}
            onClick={() => {
              const { dependentValues } = this.props;
              handleOpenEditPromotion(dependentValues.PromotionLine_id);
            }}
          >
            <Translate value="edit" />
          </Button>
        </span>
      );
    },
  });

  const ToolTipFormatter = React.createClass({
    render() {
      return (
        <span data-tip data-for={this.props.dependentValues.PromotionLine_id}>
          { this.props.value }
        </span>
      );
    },
  });

  const AutoApplyFormatter = React.createClass({
    render() {
      return (
        <span>
          {
            (this.props.value)
              ? 'Yes'
              : 'No'
          }
        </span>
      );
    },
  });

  const OneTimeFormatter = React.createClass({
    render() {
      return (
        <span>
          {
            (this.props.value)
              ? 'Yes'
              : 'No'
          }
        </span>
      );
    },
  });

  const productPromotionColumns = [
    {
      key: 'Delete',
      name: <Translate value="del" />,
      width: 50,
      formatter: IsVariableFormatter,
      getRowMetaData: row => row,
    },
    {
      key: 'Edit',
      name: <Translate value="edit" />,
      width: 55,
      formatter: EditButtonFormatter,
      getRowMetaData: row => row,
    },
    ...isOLG ? []:[
      {
        key: 'ProductNum',
        name: <Translate value="prod_num" />,
        resizable: true,
        sortable: true,
        width: 100,
        filterable: true,
      }
    ],
    {
      key: 'RefNum',
      name: <Translate value={isOLG ? "item_no" : "ref_num"} />,
      resizable: true,
      sortable: true,
      width: 90,
      filterable: true,
    },
    {
      key: 'PromoCode',
      name: <Translate value="code" />,
      resizable: true,
      sortable: true,
      width: 90,
      filterable: true,
    },
    {
      key: 'SalesType',
      name: <Translate value="sales_type" />,
      resizable: true,
      sortable: true,
      width: 100,
      filterable: true,
    },
    {
      key: 'AutoApply',
      name: <Translate value="auto" />,
      resizable: true,
      sortable: true,
      width: 70,
      filterable: true,
      formatter: AutoApplyFormatter,
      getRowMetaData: row => row,
    },
    ...(isOLG || isLMH || isSDR || isCRW) ? [{
      key: 'IsOneTime',
      name: <Translate value="one_time" />,
      resizable: true,
      sortable: true,
      width: 70,
      filterable: true,
      formatter: OneTimeFormatter,
      getRowMetaData: row => row,
    }] : [],
    {
      key: 'Name',
      name: <Translate value="name" />,
      resizable: true,
      sortable: true,
      width: 200,
      filterable: true,
    },
    {
      key: 'Description',
      name: <Translate value="description" />,
      resizable: true,
      sortable: true,
      width: 150,
      filterable: true,
    },
    {
      key: 'GroupName',
      name: <Translate value="customer_group" />,
      resizable: true,
      sortable: true,
      width: 150,
      filterable: true,
    },
    {
      key: 'DiscountDescription',
      name: <Translate value="discount_description" />,
      resizable: true,
      sortable: true,
      filterable: true,
      width: 270,
      formatter: ToolTipFormatter,
      getRowMetaData: row => row,
    },
    {
      key: 'RelatedQuantity',
      name: <Translate value="gift_quantity_column" />,
      resizable: true,
      sortable: true,
      width: 70,
      filterable: true,
    },
    {
      key: 'StartDate',
      name: <Translate value="start_date" />,
      resizable: true,
      sortable: true,
      filterable: true,
      width: 110,
      formatter: DateFormatter,

    },
    {
      key: 'EndDate',
      name: <Translate value="end_date" />,
      resizable: true,
      sortable: true,
      filterable: true,
      width: 100,
      formatter: DateFormatter,
    },
  ];

  const byQuantityDiscountColumns = [
    {
      key: 'Delete',
      name: <Translate value="del" />,
      width: 50,
      formatter: IsVariableFormatter,
      getRowMetaData: row => row,
    },
    {
      key: 'Edit',
      name: <Translate value="edit" />,
      width: 55,
      formatter: EditButtonFormatter,
      getRowMetaData: row => row,
    },
    ...isOLG ? []:[
      {
        key: 'ProductNum',
        name: <Translate value="prod_num" />,
        resizable: true,
        sortable: true,
        width: 100,
        filterable: true,
      }
    ],
    {
      key: 'RefNum',
      name: <Translate value={isOLG ? "item_no" : "ref_num"} />,
      resizable: true,
      sortable: true,
      width: 90,
      filterable: true,
    },
    {
      key: 'ProductGroupName',
      name: <Translate value="group" />,
      resizable: true,
      sortable: true,
      width: 200,
      filterable: true,
      getRowMetaData: row => row,
      formatter: ({ value, dependentValues }) => (
        <div
          style={{ width: "100%", height: "100%", textAlign: "center" }}
        >
          {((!value || value === '') && (!dependentValues.Product_id)) ? 'All' : value}
        </div>
      ),
    },
    {
      key: 'ProductCategoryName',
      name: <Translate value="category" />,
      resizable: true,
      sortable: true,
      width: 200,
      filterable: true,
      getRowMetaData: row => row,
      formatter: ({ value, dependentValues }) => (
        <div
          style={{ width: "100%", height: "100%", textAlign: "center" }}
        >
          {((!value || value === '') && (!dependentValues.Product_id)) ? 'All' : value}
        </div>
      ),
    },
    {
      key: 'Name',
      name: <Translate value="name" />,
      resizable: true,
      sortable: true,
      width: 200,
      filterable: true,
    },
    {
      key: 'Description',
      name: <Translate value="description" />,
      resizable: true,
      sortable: true,
      width: 150,
      filterable: true,
    },
    {
      key: 'GroupName',
      name: <Translate value="customer_group" />,
      resizable: true,
      sortable: true,
      width: 150,
      filterable: true,
    },
    {
      key: 'DiscountDescription',
      name: <Translate value="discount_description" />,
      resizable: true,
      sortable: true,
      filterable: true,
      width: 270,
      formatter: ToolTipFormatter,
      getRowMetaData: row => row,
    },
    {
      key: 'StartDate',
      name: <Translate value="start_date" />,
      resizable: true,
      sortable: true,
      filterable: true,
      width: 110,
      formatter: DateFormatter,

    },
    {
      key: 'EndDate',
      name: <Translate value="end_date" />,
      resizable: true,
      sortable: true,
      filterable: true,
      width: 100,
      formatter: DateFormatter,
    },
  ];
  
  const byQuantityProductColumns = [
    {
      key: 'Delete',
      name: <Translate value="del" />,
      width: 50,
      formatter: IsVariableFormatter,
      getRowMetaData: row => row,
    },
    {
      key: 'Edit',
      name: <Translate value="edit" />,
      width: 55,
      formatter: EditButtonFormatter,
      getRowMetaData: row => row,
    },
    ...isOLG ? []:[
      {
        key: 'ProductNum',
        name: <Translate value="prod_num" />,
        resizable: true,
        sortable: true,
        width: 100,
        filterable: true,
      }
    ],
    {
      key: 'RefNum',
      name: <Translate value={isOLG ? "item_no" : "ref_num"} />,
      resizable: true,
      sortable: true,
      width: 90,
      filterable: true,
    },
    {
      key: 'Name',
      name: <Translate value="name" />,
      resizable: true,
      sortable: true,
      width: 200,
      filterable: true,
    },
    {
      key: 'Description',
      name: <Translate value="description" />,
      resizable: true,
      sortable: true,
      width: 150,
      filterable: true,
    },
    {
      key: 'GroupName',
      name: <Translate value="customer_group" />,
      resizable: true,
      sortable: true,
      width: 150,
      filterable: true,
    },
    {
      key: 'DiscountDescription',
      name: <Translate value="discount_description" />,
      resizable: true,
      sortable: true,
      filterable: true,
      width: 270,
      formatter: ToolTipFormatter,
      getRowMetaData: row => row,
    },
    {
      key: 'StartDate',
      name: <Translate value="start_date" />,
      resizable: true,
      sortable: true,
      filterable: true,
      width: 110,
      formatter: DateFormatter,

    },
    {
      key: 'EndDate',
      name: <Translate value="end_date" />,
      resizable: true,
      sortable: true,
      filterable: true,
      width: 100,
      formatter: DateFormatter,
    },
  ];

  const byTotalPriceDiscountColumns = [
    {
      key: 'Delete',
      name: <Translate value="del" />,
      width: 50,
      formatter: IsVariableFormatter,
      getRowMetaData: row => row,
    },
    {
      key: 'Edit',
      name: <Translate value="edit" />,
      width: 55,
      formatter: EditButtonFormatter,
      getRowMetaData: row => row,
    },
    {
      key: 'PromoCode',
      name: <Translate value="code" />,
      resizable: true,
      sortable: true,
      width: 90,
      filterable: true,
    },
    {
      key: 'AutoApply',
      name: <Translate value="auto" />,
      resizable: true,
      sortable: true,
      width: 70,
      filterable: true,
      formatter: AutoApplyFormatter,
      getRowMetaData: row => row,
    },
    {
      key: 'IsOneTime',
      name: <Translate value="one_time" />,
      resizable: true,
      sortable: true,
      width: 70,
      filterable: true,
      formatter: OneTimeFormatter,
      getRowMetaData: row => row,
    },
    ...isAFM ? [{
      key: 'IsPublic',
      name: <Translate value="public" />,
      resizable: true,
      sortable: true,
      width: 70,
      filterable: true,
      formatter: OneTimeFormatter,
      getRowMetaData: row => row,
    }]: [],
    {
      key: 'SalesType',
      name: <Translate value="sales_type" />,
      resizable: true,
      sortable: true,
      width: 100,
      filterable: true,
    },
    {
      key: 'GroupName',
      name: <Translate value="customer_group" />,
      resizable: true,
      sortable: true,
      width: 150,
      filterable: true,
    },
    {
      key: 'PaymentType',
      name: <Translate value="payment_method" />,
      resizable: true,
      sortable: true,
      width: 200,
      filterable: true,
    },
    {
      key: 'DiscountDescription',
      name: <Translate value="discount_description" />,
      resizable: true,
      sortable: true,
      filterable: true,
      width: 260,
    },
    {
      key: 'StartDate',
      name: <Translate value="start_date" />,
      resizable: true,
      sortable: true,
      filterable: true,
      width: 110,
      formatter: DateFormatter,
    },
    {
      key: 'EndDate',
      name: <Translate value="end_date" />,
      resizable: true,
      sortable: true,
      filterable: true,
      width: 100,
      formatter: DateFormatter,
    },
  ];

  const getColumns = () => {
    if (tabsKey === 'ByTotalPriceDiscount') {
      return byTotalPriceDiscountColumns;
    }
    if (tabsKey === 'ByTotalPriceProduct') {
      return productPromotionColumns;
    }
    if (tabsKey === 'BuyAGetB') {
      return byQuantityProductColumns;
    }
    return byQuantityDiscountColumns;
  };

  return (
    <Row>
      <Col xs={12}>
        {
          (tabsKey === 'BuyAGetB') && lodashMap(promotions.rows, row => (
            <ReactTooltip id={`${row.PromotionLine_id}`} place="top" type="dark" effect="solid">
              <div className="product-b-tool-tips">
                <label htmlFor="product-b"><Translate value="product_b" /></label>
                <div className="flex-row">
                  <label htmlFor="prod-num"><Translate value="prod_num" />:</label>
                  <span>{ row.RelatedProductNum }</span>
                </div>
                <div className="flex-row">
                  <label htmlFor="ref-num"><Translate value={isOLG ? "item_no" : "ref_num"} />:</label>
                  <span>{ row.RelatedRefNum }</span>
                </div>
                <div className="flex-row">
                  <label htmlFor="name" className="item-name-label"><Translate value="name" />: </label>
                  <span className="item-name-span">{ row.RelatedName }</span>
                </div>
                <div className="flex-row">
                  <label htmlFor="description"><Translate value="desc" />: </label>
                  <span>{ row.RelatedDescription }</span>
                </div>
              </div>
            </ReactTooltip>
          ))
        }
        <div id="Promotions-dataGrid1">
          <ReactDataGrid
            rowKey="Promotion_id"
            onGridSort={handleGridSort}
            toolbar={<Toolbar enableFilter />}
            onAddFilter={handleFilterChange}
            onClearFilters={handleClearFilters}
            columns={getColumns()}
            rowGetter={rowGetter}
            rowHeight={25}
            headerRowHeight={45}
            minHeight={450}
            rowsCount={getSize()}
          />
        </div>
      </Col>
    </Row>
  );
};

PromotionsTable.propTypes = propTypes;
PromotionsTable.defaultProps = defaultProps;

export default PromotionsTable;



// WEBPACK FOOTER //
// ./master/jsx/components/Sales/PromotionsPage/components/PromotionsTable.jsx